import { useState, useEffect } from "react";
import { CooldownState } from "./types";

export const useCooldown = () => {
  const [cooldown, setCooldown] = useState(() => {
    const stored = localStorage.getItem('passwordResetCooldown');
    if (stored) {
      const { timestamp, duration } = JSON.parse(stored) as CooldownState;
      const remaining = Math.ceil((duration - (Date.now() - timestamp)) / 1000);
      return remaining > 0 ? remaining : 0;
    }
    return 0;
  });

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => {
        setCooldown(cooldown - 1);
        if (cooldown - 1 <= 0) {
          localStorage.removeItem('passwordResetCooldown');
        }
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const setCooldownWithStorage = (seconds: number) => {
    setCooldown(seconds);
    localStorage.setItem('passwordResetCooldown', JSON.stringify({
      timestamp: Date.now(),
      duration: seconds * 1000
    }));
  };

  return { cooldown, setCooldownWithStorage };
};